var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"question-type3"},[_c('b-row',[_c('div',{staticClass:"item_quesion"},[_c('div',{staticClass:"header_question"},[_c('h2',[_vm._t("question-number")],2)]),_c('div',{staticClass:"content_question row"},[_c('div',{staticClass:"item_answer ql-editor"},[_c(_vm.dynamicComponent,{tag:"component"})],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }